export { default as NavigateNextIcon } from "@mui/icons-material/NavigateNext";
